import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className={`navbar ${isMenuOpen ? 'expanded' : ''}`}>
    <div className="logo-container">
    <a href="#hero"> {/* You can replace "#hero" with "/" if you're routing to homepage */}
      <img
        src="/Images/WhatsApp Image 2025-04-05 at 00.44.10.jpeg"
        alt="R.D'S Creations Logo"
        className="logo-image"
      />
    </a>
  </div>
      <div className="menu-toggle" onClick={toggleMenu}>
        ☰
      </div>

      <ul className="nav-links">
        <li><a href="#hero" onClick={toggleMenu}>Home</a></li>
        <li><a href="#about" onClick={toggleMenu}>About</a></li>
        <li><a href="#services" onClick={toggleMenu}>Services</a></li>
        <li><a href="#testimonials" onClick={toggleMenu}>Testimonials</a></li>
        <li><a href="#gallery" onClick={toggleMenu}>Gallery</a></li>
        <li>
  <a href="https://www.instagram.com/rishabbh_doshi_creations?igsh=MXZxZXlkbWkyMnBiNQ==" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>
    Instagram
  </a>
</li>
        <li><a href="mailto:rdoshi1997@gmail.com" onClick={toggleMenu}>Email</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;